export default __webpack_public_path__ + "media/49da59fa1fc3a1719ee82f3507e152accc4f8e7d90a49373b4a73ee3875beb3a.svg";